
export const state = () => {
	return {
		data: [],
		total: 0,
		selected: null
	}
}

const initialState = Object.assign({}, state())

export const getters = {
	organizations ({ data }) {
		return data
	},
	selectedOrganization ({ selected }) {
		return selected
	},
	totalOrganizations ({ total }) {
		return total
	}
}

export const actions = {
	async createOrganization (_, data) {
		const createOrganizationData = {
			client: 'youth',
			type: 'other',
			...data
		}

		await this.$axios.$post('/api/v1/organizations/youth', createOrganizationData, { serializeBody: true })
	}
}

export const mutations = {
	RESET_STORE: (state) => {
		Object.assign(state, initialState)
	}
}
